(function () {
  'use strict';

  /* Progressive enhancement over the stock Dawn description markup, so no
     edit to main-product.liquid is needed. If this script never runs the
     description simply shows in full -- nothing is hidden by default. */

  var COLLAPSED = 420; // px of description visible before the fade
  var SLACK = 120; // don't bother collapsing if it's barely over the limit
  var built = false;
  var lazied = false;

  function getDescription() {
    var block = document.querySelector('.product__description-block');
    if (!block) return null;
    var desc = block.querySelector('.product__description');
    return desc ? { block: block, desc: desc } : null;
  }

  /* Imported supplier descriptions carry 20+ full-size images with no loading
     attribute. Leave the first eager -- it is often the largest element in
     view -- and defer the rest. (This behaviour came from the old block in
     global.js, which has been removed.) */
  function lazyLoadImages(desc) {
    if (lazied) return;
    var images = desc.querySelectorAll('img');
    if (images.length < 2) return;
    lazied = true;

    for (var i = 1; i < images.length; i++) {
      if (!images[i].hasAttribute('loading')) images[i].setAttribute('loading', 'lazy');
      if (!images[i].hasAttribute('decoding')) images[i].setAttribute('decoding', 'async');
    }
  }

  function build() {
    var found = getDescription();
    if (!found) return;

    lazyLoadImages(found.desc);

    if (built) return;

    var block = found.block;
    var desc = found.desc;

    // Short descriptions are left alone -- a toggle on four lines is noise.
    if (desc.scrollHeight <= COLLAPSED + SLACK) return;

    built = true;

    if (!desc.id) desc.id = 'EcoProductDescription';

    var wrap = document.createElement('div');
    wrap.className = 'eco-desc__wrap';
    desc.parentNode.insertBefore(wrap, desc);
    wrap.appendChild(desc);

    var fade = document.createElement('span');
    fade.className = 'eco-desc__fade';
    wrap.appendChild(fade);

    block.classList.add('eco-desc');
    desc.classList.add('eco-desc__inner');
    desc.style.maxHeight = COLLAPSED + 'px';

    var actions = document.createElement('div');
    actions.className = 'eco-desc__actions';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'eco-desc__toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', desc.id);

    var label = document.createElement('span');
    label.className = 'eco-desc__label';
    label.textContent = 'View more';
    btn.appendChild(label);

    var chev = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    chev.setAttribute('class', 'eco-desc__chev');
    chev.setAttribute('viewBox', '0 0 24 24');
    chev.setAttribute('aria-hidden', 'true');
    var poly = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
    poly.setAttribute('points', '6 9 12 15 18 9');
    chev.appendChild(poly);
    btn.appendChild(chev);

    actions.appendChild(btn);
    block.appendChild(actions);

    btn.addEventListener('click', function () {
      var open = !block.classList.contains('is-open');

      if (open) {
        block.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        label.textContent = 'View less';
        desc.style.maxHeight = desc.scrollHeight + 'px';
        /* Once the animation finishes, drop the cap entirely. These
           descriptions are full of lazy images that resize after load, and a
           fixed pixel height would clip them. */
        window.setTimeout(function () {
          if (block.classList.contains('is-open')) desc.style.maxHeight = 'none';
        }, 420);
      } else {
        desc.style.maxHeight = desc.scrollHeight + 'px';
        desc.offsetHeight; // force reflow so the transition has a start value
        block.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        label.textContent = 'View more';
        desc.style.maxHeight = COLLAPSED + 'px';

        /* Collapsing from far down the page would otherwise leave the reader
           stranded in the footer. */
        if (block.getBoundingClientRect().top < 0) {
          block.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }

  /* Re-check after load: images without width/height attributes report zero
     height until they decode, which would otherwise hide the button on a
     description that is mostly pictures. */
  window.addEventListener('load', build);
})();
